import { SRPRS } from 'components/_Assets/svg/Icon/srprs'
import { Colour } from 'components/variables'
import FoodLoversPage from '../../pages/entries/FoodLoversPage'
import { getCdnUrl } from '../api/cdn'
import { driveDestinations } from '../models/funnelOrder/driveDestination'
import { roomType } from '../models/funnelOrder/roomType'
import { Theme } from '../models/funnelOrder/theme'
import { Entry, EntryCategory, EntryKey, EntryType } from './types'

export const driveEntries: Entry[] = [
  {
    name: 'Favoriet',
    order: {
      nl: 1000,
      be: 1000,
      dk: 2,
      uk: 2,
    },
    key: EntryKey.drivePopular,
    type: EntryType.Preset,
    active: true,
    colour: Colour.almond,
    theme: Theme.drive,
    category: [EntryCategory.presets],
    card: {
      contentKey: 'drive-favoriet-content',
      photoWebp: getCdnUrl('card-road-meestgeboekt.webp'),
      photo: getCdnUrl('card-road-meestgeboekt.jpg'),
      icon: SRPRS.heart,
    },
    page: {
      name: 'drive-favoriet',
      url: {
        nl: 'autoreis-favoriet',
        be: 'autoreis-favoriet',
        uk: 'autoreis-favoriet',
        dk: 'autoreis-favoriet',
      },
      params: {
        theme: Theme.drive,
        days: 3,
        driveDestination: driveDestinations.urban,
        numberOfAdults: 2,
        numberOfChildren: 0,
        numberOfBabies: 0,
      },
      cheapest: true,
      photos: {
        alt: 'Favoriet Autoreis - man naast een BMW mini',
        src: getCdnUrl('6._drive-popular-768.jpg'),
        src1024: getCdnUrl('4._drive-popular-1024.jpg'),
        src1280: getCdnUrl('3._drive-popular-1280.jpg'),
        src1600: getCdnUrl('2._drive-popular-1600.jpg'),
        src1920: getCdnUrl('1._drive-popular-1920.jpg'),
      },
      style: {
        headingColor: 'white',
      },
    },
  },

  {
    name: 'Beste prijs',
    order: {
      nl: 2,
      be: 2,
    },
    key: EntryKey.driveCheapest,
    type: EntryType.Preset,
    active: true,
    colour: Colour.golden,
    theme: Theme.drive,
    category: [EntryCategory.presets],
    card: {
      contentKey: 'drive-beste-prijs-content',
      photoWebp: getCdnUrl('card-road-besteprijs.webp'),
      photo: getCdnUrl('card-road-besteprijs.jpg'),
      icon: SRPRS.thumbsup,
    },
    page: {
      name: 'drive-beste-prijs',
      url: {
        nl: 'autoreis-beste-prijs',
        be: 'autoreis-beste-prijs',
      },
      params: {
        theme: Theme.drive,
        days: 2,
        driveDestination: driveDestinations.surprise,
        numberOfAdults: 2,
        numberOfChildren: 0,
        numberOfBabies: 0,
      },
      cheapest: true,
      photos: {
        alt: 'Beste Prijs Autoreis - gele oldtimer fiat auto',
        src: getCdnUrl('6._drive-goedkoopste-768.jpg'),
        src1024: getCdnUrl('4._drive-goedkoopste-1024.jpg'),
        src1280: getCdnUrl('3._drive-goedkoopste-1280.jpg'),
        src1600: getCdnUrl('2._drive-goedkoopste-1600.jpg'),
        src1920: getCdnUrl('1._drive-goedkoopste-1920.jpg'),
      },
      style: {
        navbarColor: 'white',
        headingColor: 'white',
      },
    },
  },
  {
    name: 'Multi Road',
    order: {
      nl: 3,
      be: 3,
      uk: 3,
      dk: 3,
    },
    key: EntryKey.multidrive,
    type: EntryType.Flavour,
    active: true,
    colour: Colour.celadon,
    theme: Theme.drive,
    category: [EntryCategory.presets],
    card: {
      contentKey: 'multi-drive-content',
      photoWebp: getCdnUrl('card-road-multi.webp'),
      photo: getCdnUrl('card-road-multi.jpg'),
      icon: SRPRS.carPlus,
    },
    page: {
      name: 'multi-drive',
      url: {
        nl: 'multi-roadtrip',
        be: 'multi-roadtrip',
        uk: 'multi-roadtrip',
        dk: 'multi-roadtrip',
      },
      params: {
        theme: Theme.multiDrive,
        days: 3,
        locations: 2,
        driveDestination: driveDestinations.surprise,
        numberOfAdults: 2,
        numberOfChildren: 0,
        numberOfBabies: 0,
      },
      photos: {
        alt: 'Multi-Roadtrip - vrouw achter het stuur',
        src1920: getCdnUrl('1._multi-drive-1920.jpg'),
        src1600: getCdnUrl('2._multi-drive-1600.jpg'),
        src1280: getCdnUrl('3._multi-drive-1280.jpg'),
        src1024: getCdnUrl('4._multi-drive-1024.jpg'),
        src: getCdnUrl('6._multi-drive-768.jpg'),
      },
      style: {
        headingColor: 'white',
      },
    },
  },
  {
    name: 'Roadtrip XL',
    order: {
      nl: 4,
      be: 4,
    },
    key: EntryKey.ultimate,
    type: EntryType.Preset,
    active: true,
    colour: Colour.paleTurquoise,
    theme: Theme.drive,
    category: [EntryCategory.presets],
    card: {
      contentKey: 'ultimate-content',
      photoWebp: getCdnUrl('card-road-XL.webp'),
      photo: getCdnUrl('card-road-XL.jpg'),
      icon: SRPRS.carPlusPlus,
    },
    page: {
      name: 'ultimate',
      url: {
        nl: 'roadtrip-xl',
        be: 'roadtrip-xl',
      },
      params: {
        theme: Theme.multiDrive,
        locations: 7,
        days: 14,
        driveDestination: driveDestinations.surprise,
        numberOfAdults: 2,
        numberOfChildren: 0,
        numberOfBabies: 0,
      },
      photos: {
        alt: 'Roadtrip XL - miniatuur volkswagen',
        src1920: getCdnUrl('1._ultimate-drive-1920.jpg'),
        src1600: getCdnUrl('2._ultimate-drive-1600.jpg'),
        src1280: getCdnUrl('3._ultimate-drive-1280.jpg'),
        src1024: getCdnUrl('4._ultimate-drive-1024.jpg'),
        src: getCdnUrl('6._ultimate-drive-768.jpg'),
      },
      style: {
        peopleNegative: true,
      },
    },
  },
  {
    name: 'Food Lovers roadtrip',
    order: {
      nl: 1,
      be: 1,
    },
    key: EntryKey.foodLoversDrive,
    type: EntryType.Flavour,
    active: true,
    colour: Colour.lightTomato,
    theme: Theme.drive,
    category: [EntryCategory.presets],
    card: {
      contentKey: 'food-lovers-drive-content',
      photoWebp: getCdnUrl('food-lovers-entry-card-bg.webp'),
      photo: getCdnUrl('food-lovers-entry-card-bg.jpg'),
      icon: SRPRS.carPlus,
    },
    page: {
      name: 'food-lovers-drive',
      url: {
        nl: 'food-lovers-drive',
        be: 'food-lovers-drive',
      },
      params: {
        theme: Theme.foodLoversDrive,
        days: 3,
        locations: 1,
        driveDestination: driveDestinations.urban,
        numberOfAdults: 2,
        numberOfChildren: 0,
        numberOfBabies: 0,
        roomType: roomType.basic,
      },
      photos: {
        alt: 'Food Lovers',
        src: getCdnUrl('foodlovers-logo-768.jpg'),
        src1024: getCdnUrl('foodlovers-logo-1024.jpg'),
        src1280: getCdnUrl('foodlovers-logo-1280.jpg'),
        src1600: getCdnUrl('foodlovers-logo-1600.jpg'),
        src1920: getCdnUrl('foodlovers-logo-1920.jpg'),
      },
      style: {
        navbarColor: 'white',
        headingColor: 'white',
      },
      overridePage: FoodLoversPage,
    },
  },
]
